import ContactLink from "@/components/ContactLink";
import { Head, Link, usePage } from "@inertiajs/react";
import { ArrowRight, MessageCircle, BookOpen } from "lucide-react";
import HelpLayout from "@/components/help/HelpLayout";
import Faq from "@/components/help/Faq";
import { ROLES } from "@/help/roles";
import { ARTICLES } from "@/help/articles";
import { FAQS } from "@/help/faqs";

export default function Role({ role: roleSlug }) {
  const role = ROLES[roleSlug];
  if (!role) return null;
  const faqs = FAQS[roleSlug] || [];

  return (
    <HelpLayout
      roleSlug={roleSlug}
      breadcrumbs={[
        { label: "Help centre", href: "/help" },
        { label: role.label },
      ]}
      eyebrow="Help centre"
      title={`For ${role.label.toLowerCase()}`}
    >
      <Head title={`${role.label} · Help centre`} />

      <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mb-12">
        {role.description}
      </p>

      <div className="space-y-12">
        {role.sections.map((section) => (
          <section key={section.name}>
            <h2 className="font-display text-xl font-semibold text-foreground mb-4">
              {section.name}
            </h2>
            <div className="grid gap-3 sm:grid-cols-2">
              {section.slugs.map((slug) => {
                const a = ARTICLES[slug];
                if (!a) return null;
                return (
                  <Link
                    key={slug}
                    href={`/help/articles/${slug}?from=${role.slug}`}
                    className="group block rounded-xl border border-border bg-card hover:border-primary/40 hover:bg-primary/5 transition-colors p-4"
                  >
                    <div className="flex items-start gap-3">
                      <BookOpen className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                      <div className="flex-1 min-w-0">
                        <h3 className="font-display font-semibold text-foreground leading-snug">
                          {a.title}
                        </h3>
                        <p className="text-sm text-muted-foreground leading-relaxed mt-1">
                          {a.summary}
                        </p>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </section>
        ))}

        {faqs.length > 0 && (
          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
              <MessageCircle className="h-5 w-5 text-primary" />
              Frequently asked questions
            </h2>
            <Faq items={faqs} />
          </section>
        )}

        <section className="rounded-xl border border-border bg-card/40 px-6 py-5">
          <h3 className="font-display text-base font-semibold text-foreground">
            Still stuck?
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed mt-1">
            Email <ContactLink className="text-primary hover:underline">hello@pagepledge.com</ContactLink> and a real person will get back to you, usually the same day.
          </p>
        </section>
      </div>
    </HelpLayout>
  );
}
